import { useQuery } from "react-query";
import { getJudgePhaseProjectDocumentsByIdProject } from "../../services/scientific/judgePhaseProjectDocumentByIdProject";
import { PagedRequestType } from "../../types/PagedResults";
import { Key_judgePhaseProjectDocumentsByIdProject } from "../../utils/constants";


export const useGetJudgePhaseProjectDocumentsByIdProjectQuery = (data: PagedRequestType, options: any = null) =>
  useQuery(
    [Key_judgePhaseProjectDocumentsByIdProject, JSON.stringify(data)],
    () => getJudgePhaseProjectDocumentsByIdProject(data),
    options ? { ...options } : {}
  );